'use client';

import dynamic from 'next/dynamic';

export const ServiceLayer = dynamic(
  () => import('./ServiceLayerComponents.client').then((mod) => mod.ServiceLayer),
  {
    ssr: false,
    loading: () => <div>Loading...</div>,
  },
);
